import { render, staticRenderFns } from "./LayoutPrintVoucher.vue?vue&type=template&id=248196cc&scoped=true&"
import script from "./LayoutPrintVoucher.vue?vue&type=script&lang=js&"
export * from "./LayoutPrintVoucher.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPrintVoucher.vue?vue&type=style&index=0&id=248196cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248196cc",
  null
  
)

export default component.exports